export const EInvoiceProvider = {
    VNPT: "VNPT",
    MISA: "MISA",
    MISA_WEBAPP: "MISA.Webapp",
}

export const EInvoiceConfigurationExamples: Record<string, string> = {
        "VNPT": `{
    "PublishServiceUrl": "https://bvhuedemo-tt78admindemo.vnpt-invoice.com.vn/PublishService.asmx",
    "BusinessServiceUrl": "https://bvhuedemo-tt78admindemo.vnpt-invoice.com.vn/BusinessService.asmx",
    "PortalServiceUrl": "https://bvhuedemo-tt78admindemo.vnpt-invoice.com.vn/PortalService.asmx",
    "Account": "bvhuedemoadmin",
    "ACpass": "Bvhue@123",
    "UserName": "bvtphue78sv",
    "Password": "123456aA@",
    "Pattern": "1/001",
    "Serial": "C24TPN",
    "Convert": 0,
    "VATRate": 8,
    "IsSum": 0,
    "ProdUnit": "Vé",
    "ProdName": "Vé {eventName} ({ticketClassName})"
}`,
        "MISA": `{
    "ApiUrl": "https://testapi.meinvoice.vn/api/integration",
    "AppId": "7211d623-099b-11ee-8091-005056a6f699",
    "TaxCode": "6868686868-363",
    "UserName": "testmisa@yahoo.com",
    "Password": "123456Aa",
    "TicketTemplateID": "3fda332f-c0ec-4cd2-a1e7-4dfc5680c0fc",
    "SignType": 2,
    "DecimalDigits": 0,
    "VATRate": 10,
    "IsInvoiceWithCode": true,
    "IsInvoiceCalculatingMachine": true,
    "IsTicket": true,
    "InvoiceName": "Hoá đơn khác",
    "BuyerLegalName": "",
    "BuyerFullName": "Khách lẻ (người mua không lấy hóa đơn)"
}`,
        "MISA.Webapp": `{
    "ApiUrl": "https://testapi.meinvoice.vn/api/integration/webapp",
    "TaxCode": "6868686868-363",
    "UserName": "testmisa@yahoo.com",
    "Password": "123456Aa",
    "IsInvoiceWithCode": true,
    "IsInvoiceCalculatingMachine": true,
    "TicketTemplateID": "5a33d594-902e-49ca-b59d-79c5e46c5b00",
    "DecimalDigits": 0,
    "VATRate": 10
}`
    }